import { useCallback, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useOrg } from "src/hooks/useOrg";
import { askForAnything, askForQuery } from "pages/api-clients/ask";
import { SearchContext } from "src/search/useSearchContext";
import { ExploreDocument } from "./useExploreDocument";

export function useAsk(search: SearchContext, doc: ExploreDocument) {
  const [term, setSearchTerm] = useState("");
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isOpen, open] = useState(false);
  const [question, setQuestion] = useState("");
  const orgId = useOrg().id!;

  const mutation = useMutation({
    mutationFn: async ({
      text,
      anything,
    }: {
      text: string;
      anything: boolean;
    }) => {
      return anything
        ? await askForAnything(orgId, { text })
        : await askForQuery(orgId, { text });
    },
  });
  const exDoc = useRef(doc);
  exDoc.current = doc;
  const dispatch = useRef(search.params.dispatch);
  dispatch.current = search.params.dispatch;
  const submitQuestion = useCallback(
    (text: string, anything: boolean = true) =>
      mutation
        .mutateAsync({ text, anything })
        .then((data) => {
          return data;
        })
        .catch((error_) => {
          setError(error_);
          throw error_;
        }),
    [mutation]
  );
  const asking = mutation.isLoading;
  const reset = useRef(mutation.reset);
  reset.current = mutation.reset;
  const cancel = useCallback(() => {
    // TODO this doesn't do anything yet
    reset.current();
  }, []);
  return {
    error,
    asking,
    isOpen,
    open,
    question,
    setQuestion,
    submitQuestion,
    cancel,
    setSearchTerm,
    term,
  };
}
